import React, { useState, useEffect, useContext } from 'react';
import { Box, Stack, TextField, Divider, Autocomplete, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PatientFamilyView from './patientFamilyView'
import PatientDocumentView from './patientDocumentView';
import { HomeContext } from '../utils/contexts/homeContext';
import { ServiceFormContext } from '../utils/contexts/serviceFormContext';
import { GetNoToCurrencyFormat, GetNumberFromCurrencyFormat } from '../utils/extensions/functionEx';
import { DATE_DISPLAY_FORMAT } from '../startups/apiConfig';
import { FormMode } from '../utils/extensions/constantEx';

import dayjs from 'dayjs';

export default function ServiceNewForm(props) {
    const { expanded, handleAccordionChange } = props;
    const { selectedNurse, serviceTypes, patientServiceNewFormValues, SetNewFormValues, isShowValidationMsgs } = useContext(ServiceFormContext);
    const { ShowAPIError, OpenErrorAlert, homeState } = useContext(HomeContext);

    const [cleared, setCleared] = useState(false);
    const [serviceEndDate, setServiceEndDate] = useState('');

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    useEffect(() => {
        const tempFormValue = { ...patientServiceNewFormValues };

        if (tempFormValue.serviceStartDate && tempFormValue.serviceDutyDays > 0) {
            const tempEndDate = tempFormValue.serviceStartDate.add(parseInt(tempFormValue.serviceDutyDays) - 1, 'day')
            setServiceEndDate(tempEndDate.format(DATE_DISPLAY_FORMAT));

            return;
        }
        setServiceEndDate('');
    }, [patientServiceNewFormValues]);

    const handleServiceFamiliesChange = (families) => {
        const tempFormValue = { ...patientServiceNewFormValues };
        tempFormValue.patientFamilies = [...families];
        SetNewFormValues({ ...tempFormValue });
    }

    const handleDocumentChange = (docs) => {
        const tempFormValue = { ...patientServiceNewFormValues };
        tempFormValue.patientDocuments = [...docs];
        SetNewFormValues({ ...tempFormValue });
    }

    const handleRemovedPatientDocumentIdsChange = (removedPatientDocId, removedDocId) => {
        let tempRemovedIds = [];
        const tempFormValue = { ...patientServiceNewFormValues };

        if (removedPatientDocId > 0) {
            tempRemovedIds = [...tempFormValue.removedPatientDocIds];
            tempRemovedIds.push(removedPatientDocId);
            tempFormValue.removedPatientDocIds = [...tempRemovedIds];
        }
        if (removedDocId > 0) {
            tempRemovedIds = [...tempFormValue.removedDocIds];
            tempRemovedIds.push(removedDocId);
            tempFormValue.removedDocIds = [...tempRemovedIds];
        }
        SetNewFormValues({ ...tempFormValue });
    }

    return (

        <Box sx={{ padding: "16px", maxHeight: '80vh', overflowY: 'auto' }}>
            <Stack>

                <Box>
                    <Grid container spacing={2}>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Nurse Name"
                                value={selectedNurse ? selectedNurse.nurseName : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Mobile No"
                                value={selectedNurse ? selectedNurse.phoneNo : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Advance Amount" value={selectedNurse ? selectedNurse.advanceAmount : '0.00'}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>

                        </Grid>
                        <Grid size={3}>
                            <Autocomplete
                                id="combo-box-service-type"
                                options={serviceTypes} value={patientServiceNewFormValues.selectedServiceType}
                                getOptionLabel={(option) => option.service_type_name}
                                onChange={(event, newValue) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.selectedServiceType = newValue;
                                    SetNewFormValues(tempFormValue);
                                }}
                                renderInput={(params) =>
                                    <TextField {...params} label="Service Type" size="small" fullWidth required
                                        error={isShowValidationMsgs && !patientServiceNewFormValues.selectedServiceType ? true : false}
                                        helperText={isShowValidationMsgs && !patientServiceNewFormValues.selectedServiceType ? 'Select service type' : ''}
                                    />}
                            />
                        </Grid>
                        <Grid size={2}>
                            <DatePicker format="DD/MM/YYYY"
                                label="Start Date" maxDate={dayjs()}
                                minDate={dayjs().add(-3, 'day')}
                                value={patientServiceNewFormValues.serviceStartDate}
                                onChange={(newValue) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.serviceStartDate = newValue;
                                    SetNewFormValues(tempFormValue);
                                }}
                                slotProps={{
                                    textField: {
                                        size: "small", fullWidth: "true", required: "true",
                                        error: isShowValidationMsgs && !patientServiceNewFormValues.serviceStartDate ? true : false,
                                        helperText: isShowValidationMsgs && !patientServiceNewFormValues.serviceStartDate ? 'Enter start date' : ''
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => setCleared(true)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={1}>
                            <TextField size="small" fullWidth required type='number'
                                label="Duty Days"
                                error={isShowValidationMsgs && patientServiceNewFormValues.serviceDutyDays <= 0 ? true : false}
                                helperText={isShowValidationMsgs && patientServiceNewFormValues.serviceDutyDays <= 0 ? 'Enter duty days' : ''}
                                value={patientServiceNewFormValues.serviceDutyDays}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.serviceDutyDays = event.target.value ?? 0;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        {
                            <Grid size={2}>
                                <TextField size="small" fullWidth required
                                    label="End Date" value={serviceEndDate}
                                    slotProps={{
                                        input: {
                                            readOnly: true
                                        },
                                    }}
                                />
                            </Grid>
                        }
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Total Fee"
                                error={isShowValidationMsgs && patientServiceNewFormValues.serviceTotalFee <= 0 ? true : false}
                                helperText={isShowValidationMsgs && patientServiceNewFormValues.serviceTotalFee <= 0 ? 'Enter total fee' : ''}
                                value={patientServiceNewFormValues.serviceTotalFee}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.serviceTotalFee = event.target.value ?? 0;
                                    SetNewFormValues(tempFormValue);
                                }}
                                onBlur={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.serviceTotalFee = GetNoToCurrencyFormat(event.target.value ?? 0);
                                    SetNewFormValues(tempFormValue);
                                }}
                                onFocus={(event) => {
                                    const tempValue = parseFloat(event.target.value ?? 0);
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    if (tempValue > 0) {
                                        tempFormValue.serviceTotalFee = GetNumberFromCurrencyFormat(event.target.value);
                                    } else {
                                        tempFormValue.serviceTotalFee = '';
                                    }
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Nurse Salary"
                                error={isShowValidationMsgs && patientServiceNewFormValues.nurseSalary < 0 ? true : false}
                                helperText={isShowValidationMsgs && patientServiceNewFormValues.nurseSalary < 0 ? 'Enter nurse salary' : ''}
                                value={patientServiceNewFormValues.nurseSalary}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.nurseSalary = event.target.value ?? 0;
                                    SetNewFormValues(tempFormValue);
                                }}
                                onBlur={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.nurseSalary = GetNoToCurrencyFormat(event.target.value ?? 0);
                                    SetNewFormValues(tempFormValue);
                                }}
                                onFocus={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    const tempValue = parseFloat(event.target.value ?? 0);
                                    if (tempValue > 0) {
                                        tempFormValue.nurseSalary = GetNumberFromCurrencyFormat(event.target.value);
                                    } else {
                                        tempFormValue.nurseSalary = '';
                                    }
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ "margin": "10px 0", paddingTop: "10px" }}>
                    <Stack>
                        <Typography gutterBottom variant="subtitle2">
                            Patient Details
                        </Typography>
                        <Divider />
                    </Stack>
                </Box>

                <Box>
                    <Grid container spacing={2}>
                        <Grid size={5}>
                            <TextField size="small" fullWidth required
                                label="Patient Name"
                                error={isShowValidationMsgs && patientServiceNewFormValues.patientName.trim().length === 0 ? true : false}
                                helperText={isShowValidationMsgs && patientServiceNewFormValues.patientName.trim().length === 0 ? 'Enter patient name' : ''}
                                value={patientServiceNewFormValues.patientName}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.patientName = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth required
                                label="Mobile No"
                                error={isShowValidationMsgs && patientServiceNewFormValues.patientMobileNo.trim().length === 0 ? true : false}
                                helperText={isShowValidationMsgs && patientServiceNewFormValues.patientMobileNo.trim().length === 0 ? 'Enter patient mobile no' : ''}
                                value={patientServiceNewFormValues.patientMobileNo}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.patientMobileNo = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={3}>
                            <TextField size="small" fullWidth required
                                label="Place"
                                error={isShowValidationMsgs && patientServiceNewFormValues.patientPlace.trim().length === 0 ? true : false}
                                helperText={isShowValidationMsgs && patientServiceNewFormValues.patientPlace.trim().length === 0 ? 'Enter patient place' : ''}
                                value={patientServiceNewFormValues.patientPlace}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.patientPlace = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth type='number'
                                label="Delivery No"
                                value={patientServiceNewFormValues.deliveryNo}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.deliveryNo = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Address" helperText="" multiline rows={4}
                                value={patientServiceNewFormValues.patientAddress}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.patientAddress = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth label="Bus Route" helperText="" multiline
                                rows={4} value={patientServiceNewFormValues.patientBusRoute}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.patientBusRoute = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Stack spacing={2}>
                                <TextField size="small" fullWidth label="Phone 1"
                                    value={patientServiceNewFormValues.patientPhone1}
                                    onChange={(event) => {
                                        const tempFormValue = { ...patientServiceNewFormValues };
                                        tempFormValue.patientPhone1 = event.target.value;
                                        SetNewFormValues(tempFormValue);
                                    }}
                                />

                                <TextField size="small" fullWidth label="Phone 2"
                                    value={patientServiceNewFormValues.patientPhone2}
                                    onChange={(event) => {
                                        const tempFormValue = { ...patientServiceNewFormValues };
                                        tempFormValue.patientPhone2 = event.target.value;
                                        SetNewFormValues(tempFormValue);
                                    }}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={8}>
                            <TextField size="small" fullWidth label="Notes" helperText="" multiline rows={4}
                                value={patientServiceNewFormValues.serviceRemarks}
                                onChange={(event) => {
                                    const tempFormValue = { ...patientServiceNewFormValues };
                                    tempFormValue.serviceRemarks = event.target.value;
                                    SetNewFormValues(tempFormValue);
                                }}
                            />
                        </Grid>


                    </Grid>
                </Box>


                <Box>
                    <Grid container>
                        <Grid size={12}>
                            <Box sx={{ padding: "16px 0" }}>
                                <PatientFamilyView expanded={expanded} formOpenMode={FormMode.NewMode} patientFamilies={patientServiceNewFormValues.patientFamilies}
                                    handleAccordionChange={handleAccordionChange}
                                    handleServiceFamiliesChange={handleServiceFamiliesChange}
                                />

                                <PatientDocumentView expanded={expanded} patientDocuments={patientServiceNewFormValues.patientDocuments}
                                    formOpenMode={FormMode.NewMode} loggedUser={homeState.loggedUser}
                                    showAPIError={ShowAPIError} openErrorAlert={OpenErrorAlert}
                                    handleAccordionChange={handleAccordionChange} handleDocumentChange={handleDocumentChange}
                                    handleRemovedPatientDocumentIdsChange={handleRemovedPatientDocumentIdsChange} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
        </Box>
    );
}
